import React from 'react';
import {Route} from 'react-router-dom';
import AsyncPage from './async';
import BlankLayout from '../../../../components/layout/BlankLayout';

export default (
  <Route key="/perfectbeauty/skincarepro/terms-of-service" element={<BlankLayout />}>
    <Route
      path="perfectbeauty/skincarepro/terms-of-service"
      element={<AsyncPage />}
    />
  </Route>
);
